import $ from "jquery";
$(() => {
  drawTimelineLine();
  $(window).on("resize", drawTimelineLine);
  $(".js-about-us-timeline-btn").on("click", expandTimeline);
});
function drawTimelineLine() {
  const $line = $(".js-about-us-timeline-line");
  const $wrapper = $(".js-timeline");
  const $timeLineElements = $(".js-timeline-element");
  $line.css({
    height: `${$wrapper.height() - $timeLineElements.last().height()}px`
  });
}
function expandTimeline(e) {
  e.preventDefault();
  const $target = $(e.currentTarget);
  const $timeLineElements = $(".js-timeline-element");
  $target.hide();
  $timeLineElements.show();
  drawTimelineLine();
}
if (module.hot) { module.hot.accept(); }